import { ModelInstance, BaseModel, ToFrontHook, ToBackHook } from './util';
import { TournamentDisqualification } from './tournament-disqualification';

@ModelInstance({
  mappingFields: {
    tournament_team_user_id: 'tournamentTeamUserId',
    disqualification: 'disqualification'
  },
  relation: {
    disqualification: TournamentDisqualification
  }
})
export class GameUserDisqualification extends BaseModel {
  tournamentTeamUserId: number;
  disqualification: TournamentDisqualification;

  @ToFrontHook
  static toFront(data: any): any {
  }

  @ToBackHook
  static toBack(data: any): any {
  }
}
